import React from 'react'
import { SignupButton as El } from '../../AuthGoogle'

class SignupPageGoogleButton extends React.Component {

  state = {}

  onError = error => {
    if (error.id === 5107) {
      // Captcha or CSRF error
      // Show signup with appropriate error message
      window.location.assign('/signup?e=24')
    }
    else if (error.detail) {
      // It was a google error
      this.setState({errorDetail: error.detail})
    }
  }

  onSuccess = (response) => {
    window.location.assign(response.locationUrl)
  }

  render() {
    return (
      <React.Fragment>

        {/*
          Temp hack to render error message.
          TODO: Elevate state to container once we have all of signup in react
        */}
       { this.state.errorDetail &&
         <p className="login-error">{ this.state.errorDetail }</p> }

        <El
          text={ this.props.text }
          onError={ this.onError }
          onSuccess={ this.onSuccess } />
      </React.Fragment>
    )
  }
}

export {
  SignupPageGoogleButton as GoogleButton
}
